import './Checkbox.scss'
import { useEffect, useRef, type ComponentProps, type ReactNode } from 'react'
import { clx } from '../clx'

export interface CheckboxProps extends Omit<ComponentProps<'input'>, 'type'> {
  /** Visible label. Omit only when the checkbox is labelled elsewhere (aria-label). */
  label?: ReactNode
  /** Mixed state (e.g. a tree node with some children checked). */
  indeterminate?: boolean
}

export function Checkbox({ label, indeterminate = false, className, ref, ...rest }: CheckboxProps) {
  const inner = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (inner.current) inner.current.indeterminate = indeterminate
  }, [indeterminate])

  const input = (
    <input
      {...rest}
      ref={(node) => {
        inner.current = node
        if (typeof ref === 'function') ref(node)
        else if (ref) ref.current = node
      }}
      type="checkbox"
      className="checkbox__input"
      aria-checked={indeterminate ? 'mixed' : undefined}
    />
  )

  return (
    <label className={clx('checkbox', rest.disabled && 'checkbox--is-disabled', className)}>
      {input}
      {label !== undefined && <span className="checkbox__label">{label}</span>}
    </label>
  )
}
